export default {
  getRanklist: (state) => state.ranklist,
};
